<template>  
  <div class="qa-container">   
      <!-- 问题列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="qa-list">
        <div 
          class="qa-item" 
          v-for="item in myList" 
          :key="item.qaid"
          @click="jumpToDetail(item)"
        >
          <div class="qa-header">
            <van-icon name="question" class="qa-icon" />
            <div class="qa-content">
              <h3 class="qa-title">{{ item.title }}</h3>
            </div>
            <van-icon name="arrow" class="arrow-icon" />
          </div>
        </div>
      </div>
    </van-list>

    <!-- 空状态 -->
    <div v-if="myList.length === 0 && finished" class="empty-state">
      <van-empty description="暂无相关问题" image="search">
        <van-button 
          round 
          type="primary" 
          class="retry-btn"
          @click="getDataList"
        >
          重新加载
        </van-button>
      </van-empty>
    </div>

    <!-- 问题详情弹窗 -->
    <van-dialog 
      v-model="showModal" 
      class="content-dialog"
      :show-confirm-button="true"
      confirm-button-text="了解了"
      close-on-click-overlay
    >
      <div class="dialog-header">
        <van-icon name="description" class="dialog-icon" />
        <h3 class="dialog-title">{{ title }}</h3>
      </div>
      <div class="dialog-content">
        <div v-html="content" class="content-text"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
	import Vue from 'vue'
	import { Dialog, List } from 'vant';

	export default {
	  name: 'QAList',
    props:{
      host:String,
      models:String,
      sn: String,
    },
	  data(){
      return{			
        myList: [],
        loading: false,
        finished: false,
        error: false,
        content:'',
        title:'',
        showModal:false
      }
    },   
    created(){	     
      console.log(this.host,this.models,this.sn,'host')      
      this.getDataList()   
    },		        
	  methods:{  
      jumpToDetail(e){
        this.content = e.contents
        this.title = e.title
        this.showModal = true
      },
      onLoad(){
        setTimeout(() => {              
          this.loading = false;               
        }, 1000);
      },        
      getDataList(){
        let that = this 
        this.loading = true;
        this.error = false;
        
        Vue.axios.get('https://t3.lenovoimage.com/api/web2/qalist?model=' + this.models + '&sn=' + this.sn)
        .then(function (res) {
          that.myList = res.data.Data;
          console.log("myList:",that.myList);
          that.loading = false;
          that.finished = true;
        })
        .catch(function (error) {
          console.log(error);
          that.loading = false;
          that.error = true;
        });                   
      }
	  }
  }
</script>

<style scoped>
.qa-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding: 0;
}

.page-header {
  background-color: #ffffff;
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 4px;
}

.page-subtitle {
  font-size: 14px;
  color: #969799;
  margin: 0;
}

.qa-list {
  padding: 12px;
}

.qa-item {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.qa-item:active {
  background-color: #f5f5f5;
  transform: scale(0.98);
}

.qa-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.qa-icon {
  color: #1989fa;
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.qa-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.qa-title {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  line-height: 1.4;
  margin: 0;
  word-break: break-all;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.arrow-icon {
  color: #969799;
  font-size: 14px;
  margin-top: 2px;
  flex-shrink: 0;
}

.empty-state {
  padding: 40px 20px;
}

.retry-btn {
  margin-top: 16px;
}

/* 弹窗样式 */
.content-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  gap: 10px;
}

.dialog-icon {
  color: #1989fa;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 15px;
  font-weight: bold;
  color: #323233;
  margin: 0;
  line-height: 1.4;
  word-break: break-all;
  text-align: left;
  flex: 1;
}

.dialog-content {
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
}

.content-text {
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #323233;
  text-align: left;
}

.content-text :deep(*) {
  max-width: 100%;
  word-break: break-all;
  text-align: left;
}

.content-text :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.content-text :deep(p) {
  margin-bottom: 12px;
  text-align: left;
}

.content-text :deep(ul), 
.content-text :deep(ol) {
  padding-left: 20px;
  margin-bottom: 12px;
  text-align: left;
}

.content-text :deep(li) {
  margin-bottom: 4px;
  text-align: left;
}

/* 响应式设计 */
@media (max-width: 360px) {
  .qa-list {
    padding: 8px;
  }
  
  .qa-item {
    padding: 12px;
    margin-bottom: 6px;
  }
  
  .qa-title {
    font-size: 13px;
  }
  
  .page-header {
    padding: 14px;
  }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .qa-item:hover {
    background-color: #f7f8fa;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}
</style>